import { MessageCircle } from "lucide-react";

export const FloatingWhatsApp = () => {
  return (
    <a
      href="#tim-sales"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="absolute inset-0 rounded-full bg-animax-orange/40 blur-xl group-hover:blur-2xl transition-all animate-pulse" />
      <div className="relative flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full bg-animax-orange text-white shadow-lg shadow-animax-orange/30 hover:bg-animax-yellow hover:text-animax-black transition-all">
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-medium hidden sm:inline">Hubungi Tim Sales</span>
      </div>
    </a>
  );
};
